
export const apiEndPoint = process.env.REACT_APP_API

export const login = `${apiEndPoint}/auth/create-session`
export const logout = `${apiEndPoint}/auth/logout`
export const checkSession = `${apiEndPoint}/auth/check-session`
export const magiclogin = `${apiEndPoint}/auth/magic-login`
export const searchDocuments = (collection:string) =>  `${apiEndPoint}/search/${collection}`
export const getVolum = ({volumId, volumColl, domainId}:{volumId:string, volumColl:string, domainId?:string}) => `${apiEndPoint}/volums/specializeds/${volumColl}/${volumId}${domainId ? `?domainId=${domainId}` : ''}`
export const storageUrl = process.env.REACT_APP_STORAGEURL
export const instantlogin = (url:string) => `${url}/auth/create-instant-login-token`

export const apiEndPointStaging = process.env.REACT_APP_API_STAGING
export const apiEndPointProd =process.env.REACT_APP_API_PROD
